import { getAugmentedNamespace as e } from "./_commonjsHelpers.js";
import * as m from "../node_modules/memoize-one/dist/memoize-one.esm.js";
const r = /* @__PURE__ */ e(m);
export {
  r as default
};
